<script setup lang='ts'>
const circleRef = useTemplateRef("circleRef")

defineExpose({
	circleRef,
})
</script>

<template>
	<div
		ref="circleRef"
		class="z-10 size-fit flex items-center justify-center">
		<slot />
	</div>
</template>
